import produce from 'immer';
import { Action } from '../../redux/types';
import { stationAppPanel } from './PanelStationAppState';

export const stationAppPanelReducer = (state = stationAppPanel, action: Action) => {
  return produce(state, (draft) => {
    return draft;
  });
};
